import { useTranslation } from "react-i18next";
import PageLayout from "@/components/feature/PageLayout";
import LegalSections from "@/pages/legal/LegalSections";
import { useLang } from "@/lib/useLang";
import { PRIVACY } from "@/data/pages";

export default function PrivacyPage() {
  const { t } = useTranslation();
  const lang = useLang();
  const p = PRIVACY[lang];

  return (
    <PageLayout eyebrow="PRIVACY POLICY" title={t("footer.privacy")} desc={`${t("legal.effective")}: ${p.effective}`}>
      <div className="max-w-3xl">
        <p className="text-foreground-700 leading-relaxed mb-10">{p.intro}</p>
        <LegalSections sections={p.sections} />
      </div>
    </PageLayout>
  );
}
